import {
  Component,
  OnInit,
  Inject,
  AfterViewInit,
  ViewChild,
  OnDestroy,
  HostListener,
  ViewChildren,
  ElementRef,
  Renderer2,
  ChangeDetectorRef
} from '@angular/core';
import { MatDialog, MatDialogRef, MatExpansionPanel, MatOption, MatSelect } from '@angular/material';
import { UserGroupService } from 'src/app/core/services/user-group.service';
import { Observable, of, ReplaySubject, Subject, Subscription } from 'rxjs';
import { NotificationService } from 'src/app/core/services/notification.service';
import { FormControl, NgForm } from '@angular/forms';
import { WarningComponent } from 'src/app/shared/components/warning/warning.component';
import { delay, first, map, startWith, takeUntil } from 'rxjs/operators';
import { Message } from 'src/app/core/class/message';
import { ToastrService } from 'ngx-toastr';
import { CommonService } from 'src/app/core/services/common.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Location } from '@angular/common';
import { BreadcrumbsService } from 'src/app/shared/components/breadcrumbs/breadcrumbs.service';
import { NzFormatBeforeDropEvent, NzFormatEmitEvent } from 'ng-zorro-antd';
import { ErrorCode } from 'src/app/core/constants/error-code';
import { PopupReloadPageComponent } from '../popup-reload-page/popup-reload-page.component';
import { FeatureGroup } from 'src/app/core/constants/permission';
import { PermissionConfig, PERMISS_DIVISION, PERMISS_DIVISION_DATA_OLD } from 'src/app/core/constants/permission-config';
import { CustomerService } from 'src/app/core/services/customer.service';

@Component({
  selector: 'app-autho-user-group',
  templateUrl: './autho-user-group.component.html',
  styleUrls: ['./autho-user-group.component.scss']
})
export class AuthoUserGroupComponent implements OnInit, AfterViewInit, OnDestroy {

  searchTypeCtrl2: FormControl = new FormControl(null);
  listTypes2: any[] = [];
  isServiceTypesLoading = false;
  isStatusCreateDocument: boolean = false;
  listTags2: any[] = [];
  isSelectAllDocType2: boolean = false;
  isSearchOptionAllDocType2: boolean = true;
  isSearchOptionVirtual2: boolean = true;
  @ViewChild('documentTypeSelect2', { static: false }) documentTypeSelect2: MatSelect;
  @ViewChild('allSelectedDocumentType2', { static: false }) allSelectedDocumentType2: MatOption;
  selectDocTypeMap2 = new Map();
  manageContractCreate2: any;
  docTypeSelected2: string = '';
  serviceTypePermission2: any[] = [];
  public filteredServiceTypes2: ReplaySubject<comboBox[]> = new ReplaySubject<comboBox[]>(1);

  // Tree
  enterpriseType: string = '';
  searchTypeCtrl: FormControl = new FormControl(null);
  selectControl: any = '';
  listTypes: any[] = [];

  nodeId: string;
  parentId: string;
  key: string | undefined;
  nodeType: string | undefined;

  infoNodeBetweenUser = {
    id: '',
    type: ''
  }

  defaultCheckedKeys: any[] = [];
  defaultCheckedKeysDigital: any[] = [];
  defaultExpandedKeys: any[] = [];
  tempDataToTree: any[];
  featuresTree: any[] = [];
  dataTreeSelected: any[] = [];

  treeFormControl: FormControl = new FormControl('');
  treeFormControlDigital: FormControl = new FormControl('');
  valueSearchTreeOld: string = '';
  valueSearchTreeOldDigital: string = '';
  dataTreeSelectedDigital: any[] = [];
  tempDataToTreeDigital: any[];
  featuresTreeDigital: any[] = [];
  defaultExpandedKeysDigital: any[] = [];
  dataVirtualCheckedKeysDigital: any[] = [];
  listDataTreeSelectedDigital: any[] = [];

  isStatusDocument: boolean = true;
  manageContractCreate: any;
  manageContractDigital: any;

  listDataTreeSelected: any[] = [];
  dataVirtualCheckedKeys: any[] = [];
  isSearchDataEmpty: boolean = false;
  isSearchDataDigitalEmpty : boolean = false;
  isSearchOptionAllDocType: boolean = true;
  isSearchOptionVirtual: boolean = true;
  isStopStream: boolean = false;
  isStatusDigital: boolean = false;
  isStatusDataDigital: boolean = false;


  @ViewChild('documentTypeSelect', { static: false }) documentTypeSelect: MatSelect;
  @ViewChild('allSelectedDocumentType', { static: false }) allSelectedDocumentType: MatOption;
  selectDocTypeMap = new Map();
  listTags: any[] = [];
  isSelectAllDocType: boolean = false;
  listFullServiceTypes: any[] = [];
  currentIndex: number = 0;
  constructor(
    private sv: UserGroupService,
    private dialog: MatDialog,
    public notificationService: NotificationService,
    private message: Message,
    private toastr: ToastrService,
    public commonService: CommonService,
    private renderer: Renderer2,
    private activatedRoute: ActivatedRoute,
    private location: Location,
    private router: Router,
    private cd: ChangeDetectorRef,
    private breadcrumbsService: BreadcrumbsService,
    private customerService: CustomerService,
  ) {
    const digitalFeature = JSON.parse(localStorage.getItem('featureStatus'));
    digitalFeature.map(item => {
      if (item.permission === 10) {
        this.digitalStatus = item.status;
      }
    });
  }
  groupUserId: string = '';
  checkAll = false;
  dataRole: any;
  digitalStatus;
  featuresGroups: any;
  features: any;
  subSignPermission: any;
  subManagerPermission: any;
  subSign: any;
  change = false;
  permissionInGroup: any;
  signPermission: any;
  managerPermission: any;
  permissions: any;
  userType: any;
  isShowDigitalContract: boolean = false;
  grDefualt = {
    featureGroupIds: [],
    managerPermissionServiceType: [],
    signPermissionServiceTypes: [],
    managerServiceTypeFeatureGroupId: '',
    signServiceTypeFeatureGroupId: '',
    name: '',
    description: '',
    permissions: null,
    version: null,
    groupUserDataPermissionDigitalDTOS: []
  };
  grIdDefualt = {
    managerServiceTypeFeatureGroupId: '',
    signServiceTypeFeatureGroupId: ''
  };
  grId = this.grIdDefualt;
  grUs = this.grDefualt;
  isFormChanging = false;
  formChangesSubscription: Subscription;
  docTypeSelected: string = '';


  isMultiCreateUserGroup = false;
  urlApi = '/users/group-user';

  checkFocus = true;
  serviceTypes: {id: string, name: string, code: string}[] = [];
  serviceTypes2: {id: string, name: string, code: string}[] = [];
  serviceTypePermission = [];
  showCreateSideError = false;

  public filteredServiceTypes: ReplaySubject<comboBox[]> = new ReplaySubject<comboBox[]>(1);

  serviceTypesFilterCtrl: FormControl = new FormControl();
  serviceTypesFilterCtrl2: FormControl = new FormControl();
  private _onDestroy = new Subject<void>();

  @ViewChild('customPanel', { static: false }) panel: MatExpansionPanel;
  @ViewChild('togglePanelButton', { static: false }) togglePanelButton: ElementRef;
  @ViewChild('f', { static: false }) ngForm: NgForm;

  @ViewChildren('focus') focus;

  ngOnInit() {

    this.serviceTypesFilterCtrl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(
        () => {
          this.commonService.filterCertificateType(this.serviceTypes, this.serviceTypesFilterCtrl, this.filteredServiceTypes);
        });

    this.serviceTypesFilterCtrl2.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(
        () => {
          this.commonService.filterCertificateType(this.serviceTypes2, this.serviceTypesFilterCtrl2, this.filteredServiceTypes2);
        });

    this.getServiceTypeByEnterprise();

    this.searchDocumentType();
    this.searchDocumentType2();

    this.loadData();

    this.breadcrumbsService.store([
      { label: 'breadcrumbs.home', url: 'analysis-report', params: [], highlight: false },
      { label: 'breadcrumbs.enterprise_manage', url: '', params: [], highlight: false },
      { label: 'breadcrumbs.enterprise_groupuser', url: 'user-group', params: [], highlight: false },
      { label: 'breadcrumbs.enterprise_decentralization_group_user', url: 'autho-user-group', params: [this.groupUserId], highlight: false },
    ]);
  }

  ngAfterViewInit() {
    // setTimeout(_ => this.focus.first.nativeElement.focus(), 200);
    this.formChangesSubscription = this.ngForm.form.statusChanges.subscribe(() => {
      if (this.ngForm.dirty) {
        this.isFormChanging = true;
      }
    });
  }

  /**
   * Implement ngOnDestroy method, unsubscribe error service to avoid memory leak
   */
  ngOnDestroy() {
    this.formChangesSubscription.unsubscribe();
  }

  /**
   * Update permission
   */
  onCreateSave(groupName) {
    // if (this.isFormChanging || this.change) {
      const dialogRef = this.dialog.open(WarningComponent, {
        width: '350px',
        // them ten nhom
        data: this.commonService.format(this.message.getMessage('messages.autho_us_gr'), groupName)
      });

      dialogRef.afterClosed().subscribe(rs => {
        if (rs) {
          if (!this.isStatusDocument) {
            this.dataTreeSelected = [...[]];
            // this.serviceTypePermission = [...[]];
            this.isSelectAllDocType = false;
          }
          if (!this.isStatusCreateDocument) {
            this.isSelectAllDocType2 = false;
          };
          if (!this.isStatusDigital) {
            this.dataTreeSelectedDigital = [...[]];
          }

          if(this.dataTreeSelected.filter((data) => data.dataType === 'NODE_BETWEEN_USER').length) {
            this.sv.getTreeNodes({ parentId: this.infoNodeBetweenUser.id, parentType: this.infoNodeBetweenUser.type }).subscribe((rs) => {
              if(rs && rs.data && rs.data.length) {
                this.createSave();
                return;
              }
              this.dataTreeSelected = [...this.dataTreeSelected.filter((data) => data.dataId !== this.infoNodeBetweenUser.id)];
              this.dataTreeSelected = [...this.dataTreeSelected.filter((data) => data.parentId !== this.infoNodeBetweenUser.id)];
              this.createSave();
            });
            return;
          }

          this.createSave();
        }
      });
    // } else {
    //   this.router.navigate(['/home-enterprise/user-group']);
    // }
  }

  openPopupLoadPage(message: string) {
    const dialogRef = this.dialog.open(PopupReloadPageComponent, {
      width: '500px',
      data: message
    });

    dialogRef.afterClosed().subscribe(rs => {
      if(rs) {
        this.router.navigate(['/home-enterprise/user-group'], { skipLocationChange: true }).then(() => {
          this.router.navigate(['/home-enterprise/autho-user-group', this.groupUserId]);
        });
      }
    });
  }

  createSave() {
    // if(this.isStatusDocument && !this.dataTreeSelected.length) {
    //   // this.toastr.error(this.message.getMessage('user_group.message_data_tree_changed'));
    //   this.openPopupLoadPage();
    //   this.isStopStream = true;
    //   return;
    // }

    // this.dataTreeSelected.forEach((item) => {
    //   if (this.dataTreeSelected.filter(i => i.dataId === item.dataId).length > 1) {
    //     this.isStopStream = true;
    //   }
    // });

    // if(this.isStopStream) {
    //   // this.toastr.error(this.message.getMessage('user_group.message_data_tree_changed'));
    //   this.openPopupLoadPage();
    //   return;
    // }

    // if (this.isStatusDocument && this.isStatusDigital && this.isStatusDataDigital && this.dataTreeSelected.length == 0 && this.dataTreeSelectedDigital.length == 0) {
    //   this.toastr.error(this.message.getMessage('user_group.message_data_tree_no'))
    //   return;
    // }
    if (this.isStatusDocument && this.dataTreeSelected.length == 0) {
      this.toastr.error(this.message.getMessage('user_group.message_data_tree_no_data'))
      return;
    }
    if (this.isStatusDocument && this.dataTreeSelected.length && !this.serviceTypePermission.length && !this.isSelectAllDocType) {
      this.toastr.error(this.message.getMessage('user_group.error_not_select_doc_type'))
      return;
    }
    if (this.isStatusDigital && this.isStatusDataDigital && this.dataTreeSelectedDigital.length == 0) {
      this.toastr.error(this.message.getMessage('user_group.message_data_tree_no_digital'))
      return;
    }
    if (  this.check406Active() && this.dataListGroupCustomer.length == 0) {
      this.toastr.error(this.message.getMessage('user_group.message_data_no_group_customer'))
      return;
    }

    const dataUpdate = {
      groupId: this.groupUserId,
      version: this.grUs.version,
      // name: this.grUs.name,
      // description: this.grUs.description,
      // enterpriseId: localStorage.getItem('enterpriseId'),
      featureGroupIds: this.getPermission(),
      signPermissionServiceTypes: this.getSubSignPermission(),
      managerPermissionServiceType: this.getManagerPermissionServiceType(),
      managerPermissionCreateContractServiceType: this.serviceTypePermission2,
      groupUserDataPermissionDTOS: this.dataTreeSelected,
      groupUserDataPermissionDigitalDTOS : this.isStatusDataDigital ? this.dataTreeSelectedDigital : [],
      dataType: this.isSelectAllDocType ? 'ALL_SERVICE_TYPE' : null,
      groupCustomerIds: this.check406Active() ? this.dataListGroupCustomer.map(item => item.id) : []
    };
    this.sv.authoUserGroupEnterprise(
      dataUpdate,
      () => {
        this.toastr.success(this.message.getMessage('user_group.update_user_group_success'));
        this.router.navigate(['/home-enterprise/user-group']);
      },
      () => {
        this.loadData();
      },
      (rs) => {
        // if(rs.code == ErrorCode.GroupUserNotBelong || rs.code == ErrorCode.GroupUserDataPermissionNotFound) {
        //   // this.toastr.error(rs.message);
        //   this.openPopupLoadPage(rs.message);
        //   this.isStopStream = true;
        //   return;
        // }
        console.log(rs);
        
        if(
          rs.code == ErrorCode.GroupUserServiceTypeDeleted ||
          rs.code == ErrorCode.GroupUserDepartmentDeleted ||
          rs.code == ErrorCode.GroupUserNoCreateSideDocumentPermission ||
          rs.code == ErrorCode.GroupUserServiceTypeAndDataPermissionNotMatch ||
          rs.code == ErrorCode.GroupUserServiceTypeNotPermission ||
          rs.code == ErrorCode.GroupUserDataPermissionNotPermission ||
          rs.code == ErrorCode.GroupUserNotPermission ||
          rs.code == ErrorCode.GroupUserNotBelong ||
          rs.code == ErrorCode.GroupUserDataPermissionNotFound ||
          rs.code == ErrorCode.DeleteDepartmentNormal ||
          rs.code == ErrorCode.DeleteDepartmentDigital ||
          rs.code == ErrorCode.DeleteUserNormal ||
          rs.code == ErrorCode.DeleteUserDigital ||
          rs.code == ErrorCode.GroupUserDataNormal ||
          rs.code == ErrorCode.GroupUserDataDigital ||
          rs.code == ErrorCode.GroupUserDataNotFoundNormal ||
          rs.code == ErrorCode.GroupUserDataNotFoundDigital || 
          rs.code == ErrorCode.GROUP_CUSTOMER_DOES_NOT_EXIST
          ) {
          this.toastr.error(rs.message);
          return;
        }
      }
    );
  }

  private verifyCheckAllStage() {
    const arrayAllRole = this.dataRole.filter(e => e.code !== 'ae.qlshhd' && e.code != 'ae.qlhdct.gh');
    this.checkAll = arrayAllRole.every((item: { active: any; }) => {
      return item.active;
    });
    this.change = true;
  }

  permissionChanged(group: any) {
    const permission = this.dataRole.find((item: { id: string; }) => item.id === group.id);
    if (group.id === this.grUs.signServiceTypeFeatureGroupId && permission.subSignPermission) {
      permission.subSignPermission.map((item: { active: boolean; }) => {
        permission.active ? item.active = true : item.active = false;
      });
    }

    const listCodePermissionCustomerManagement: String[] = ['401.tmkh', '402.xdskh', '403.cntbdskh', '404.qlnkh', '405.xdlkh', '406.xmnkh'];
    if(group.code === 'ae.qlttkh') {
      this.dataRole.map(item => {
        if (listCodePermissionCustomerManagement.includes(item.code)) {
          item.active = permission.active;
          return item;
        }
      });
    }


    if(listCodePermissionCustomerManagement.includes(group.code)) {
      if(this.dataRole.filter((item) => listCodePermissionCustomerManagement.includes(item.code)).every((data) => data.active)) {
        this.dataRole.map(item => {
          if (item.code === 'ae.qlttkh') {
            item.active = true;
            return item;
          }
        });
      } else if(this.dataRole.filter((item) => listCodePermissionCustomerManagement.includes(item.code)).some((data) => !data.active)) {
        this.dataRole.map(item => {
          if (item.code === 'ae.qlttkh') {
            item.active = false;
            return item;
          }
        });
      } else {
      }
    }


    /* remove service type permission list when uncheck create */
    if (group.id === this.grUs.managerServiceTypeFeatureGroupId && !permission.active) {
      this.serviceTypePermission = [];
    }

    const permission402 = [ '406.xmnkh', '402.xdskh']
    if(group.code === '402.parent.406'){
      this.dataRole.map(item => {
        if (permission402.includes(item.code)) {
          item.active = permission.active;
          return item;
        }
      });
    }
    if(permission402.includes(group.code)) {
      if(this.dataRole.filter((item) => permission402.includes(item.code)).every((data) => data.active)) {
        this.dataRole.map(item => {
          if (item.code === '402.parent.406') {
            item.active = true;
            return item;
          }
        });
      } else if(this.dataRole.filter((item) => permission402.includes(item.code)).some((data) => !data.active)) {
        this.dataRole.map(item => {
          if (item.code === '402.parent.406') {
            item.active = false;
            return item;
          }
        });
      } 
    } else {
      this.dataRole.map(item => {
        if (item.code === '402.parent.406') {
          item.active = this.dataRole.find((item) => item.code == '406.xmnkh').active && this.dataRole.find((item) => item.code == '402.xdskh').active;
          return item;
        }
      });
    }

    this.verifyCheckAllStage();
  }

  checkIndeterminate(): boolean {
    const listCodePermissionCustomerManagement: String[] = ['401.tmkh', '402.xdskh', '403.cntbdskh', '404.qlnkh', '405.xdlkh', '406.xmnkh'];
    return this.dataRole.filter((item) => listCodePermissionCustomerManagement.includes(item.code)).some((data) => !data.active) && !this.dataRole.filter((item) => listCodePermissionCustomerManagement.includes(item.code)).every((data) => !data.active)
  }

  checkIndeterminate402(): boolean {
    const listCodePermissionCustomerManagement: String[] = ['402.xdskh', '406.xmnkh'];
    return this.dataRole.filter((item) => listCodePermissionCustomerManagement.includes(item.code)).some((data) => !data.active) && !this.dataRole.filter((item) => listCodePermissionCustomerManagement.includes(item.code)).every((data) => !data.active)
  }

  /**
   * Handle when click check all icon
   */
  checkAllPermission() {
    this.dataRole.map(item => {
      if (item.code != 'ae.qlshhd' && item.code != 'ae.qlhdct.gh' && this.noIncludePermissions(item.code)) {
        item.active = this.checkAll;
        if (item.subSignPermission) {
          item.subSignPermission.map(subitem => subitem.active = this.checkAll);
        }
        return item;
      }
    });
  }

  decodeId(id: string) {
    const idDecode = atob(id);
    const findNumber = idDecode.match(/[0-9]{1,}/g);
    if (findNumber && findNumber.length) {
      return Number(findNumber[findNumber.length - 1]);
    }
    return null;
  }

  /**
   * Get permission
   */
  private getPermission() {
    let tempRole: any;
    tempRole = this.dataRole.filter(role => role.active && !(role.code == 'ae.qlttkh' || role.code == '402.parent.406'));
    if(this.isStatusDocument === true) {
      tempRole.push(this.manageContractCreate);
    } else {
      tempRole = tempRole.filter(item => item.code !== 'ae.qlhdct')
    }
    if (this.isStatusCreateDocument === true) {
      tempRole.push(this.manageContractCreate2);
    } else {
      tempRole.filter((data) => data.code !== 'ae.qllhd')
    }
    if (this.isStatusDigital === true) {
      tempRole.push(this.manageContractDigital);
    } else {
      tempRole = tempRole.filter(item => item.code !== 'ae.qlshhd')
    }
    if (this.isStatusSharePartner === true) {
      tempRole.push(this.manageContractShare);
    } else {
      tempRole = tempRole.filter(item => item.code !== 'ae.qlhdcs')
    }
    if (this.isStatusContractStandardization === true) {
      tempRole.push(this.manageContractStandardization);
    } else {
      tempRole = tempRole.filter(item => item.code !== 'hdld.pqch')
    }
    if (this.isStatusContractDossier === true) {
      tempRole.push(this.manageContractDossier);
    } else {
      tempRole = tempRole.filter(item => item.code !== 'hdld.qlbhs')
    }
    tempRole = tempRole.map(item => {
      return item.id;
    });
    tempRole = Array.from(new Set(tempRole))
    return tempRole;
  }

  /**
   * Event handle check/uncheck parent sign permission
   */
  subSignChange(group: any) {
    group.active = group.subSignPermission.every((item: { active: any }) => {
      return item.active;
    });
    this.verifyCheckAllStage();
    this.change = true;
  }

  /**
   * Get sub permission for sign document
   */
  private getSubSignPermission() {
    let tempRole: any;
    this.dataRole.map(x => {
      if (x.id === this.grUs.signServiceTypeFeatureGroupId && x.subSignPermission) {
        tempRole = x.subSignPermission.filter(rs => {
          return rs.active;
        });
        tempRole = tempRole.map(item => {
          return item.id;
        });
        return tempRole;
      } else {
        tempRole = [];
      }
    });
    return tempRole;
  }

  /**
   * Load all feature
   */
  async loadFuture() {
    this.features = await this.sv.getAllFeatures().toPromise();
    // console.log("2. res: ", this.features.data);
    this.featuresGroups = await this.sv.getAllFeaturesGroups().toPromise();
    const checkDigitalData = this.featuresGroups.data.filter(e => e.code == 'ae.qlshhd');
    this.permissions = JSON.parse(localStorage.getItem('permissions')) || '';
    if (checkDigitalData.length > 0 && this.permissions.includes(FeatureGroup.MANAGE_USER)) {
      this.isShowDigitalContract= true;
    } else {
      this.isShowDigitalContract= false;
    }
    // .log("3. res: ", this.featuresGroups.data);
    this.subSignPermission = await this.sv.getServiceType(localStorage.getItem('enterpriseId')).toPromise();
    // console.log("4. res: ", this.subSignPermission.data);
    this.permissionInGroup = this.grUs.featureGroupIds;
    // console.log("permissionInGroup: ", this.permissionInGroup);
    this.signPermission = this.grUs.signPermissionServiceTypes;
    // console.log("signPermission: ", this.signPermission);
    this.mapGroupUser();
  }

  /**
   * Load data to update
   */
  private loadData() {
    this.groupUserId = this.activatedRoute.snapshot.paramMap.get('id');
    this.sv.getGroupUserById(this.groupUserId).subscribe(rs => {
      console.log(rs.data);
      if (rs != null && rs.data != null) {
        this.grUs = rs.data;
        this.serviceTypePermission = [...rs.data.managerPermissionServiceType];
        if (this.grUs.description == null) {
          this.grUs.description = '';
        }
        if (this.grUs.groupUserDataPermissionDigitalDTOS !== undefined && this.grUs.groupUserDataPermissionDigitalDTOS.length > 0) {
          this.isStatusDataDigital = true;
        } else {
          this.isStatusDataDigital = false;
        }
        
        this.dataListGroupCustomer = rs.data.groupUserCustomerGroupPermissionDTOS.map(item => {
          return {
            name: item.groupCustomerName,
            id: item.groupCustomerId,
            customerIds:item.groupUserId,
          }
        })

        this.sv.getAllFeaturesGroups().subscribe((featureGroup) => {
          if(featureGroup && featureGroup.data) {
            // check du lieu lap hd
            if(rs.data.featureGroupIds && rs.data.featureGroupIds.length && rs.data.featureGroupIds.includes(featureGroup.data.find((feature) => feature.code === 'ae.qllhd').id)) {
              if(rs.data.managerPermissionCreateContractServiceType.length) { 
                rs.data.managerPermissionCreateContractServiceType.forEach(serviceTypeId => {
                  this.listTypes2 = [...this.listTypes2.filter((serviceType) => serviceTypeId !== serviceType.id)];
                  if(this.serviceTypes2.filter((serviceType) => serviceType.id === serviceTypeId).length) {
                    this.listTags2.push(this.serviceTypes2.find((serviceType) => serviceType.id === serviceTypeId));
                    this.selectDocTypeMap2.set(serviceTypeId, this.serviceTypes2.find((serviceType) => serviceType.id === serviceTypeId));
                  }
                  this.serviceTypes2 = [...this.serviceTypes2.filter((serviceType) => serviceType.id !== serviceTypeId)];
                });
                setTimeout(() => {
                  this.listTags2 = [...this.listTags2.filter((data) => data !== undefined)];
                  this.serviceTypePermission2 = [...this.listTags2.map((data) => data.id)];
                }, 1000);
              } else {
                this.isSelectAllDocType2 = true;
                this.listTypes2 = [...[]];
                this.serviceTypes2 = [...[]];
              }

              this.isStatusCreateDocument = true;
            } else {
              this.isStatusCreateDocument = false;
            }
            // check dữ liêu hđ
            if(rs.data.featureGroupIds && rs.data.featureGroupIds.length && rs.data.featureGroupIds.includes(featureGroup.data.find((feature) => feature.code === 'ae.qlhdct').id)) {
              if(rs.data.groupUserDataPermissionDTOS && rs.data.groupUserDataPermissionDTOS.length) {
                const enterpriseType = localStorage.getItem('isParent') == 'true' ? 'COMPANY' : 'BRANCH';
                this.listDataTreeSelected = [...rs.data.groupUserDataPermissionDTOS.map((data) => ({
                  ...data,
                  id: data.dataId,
                  type: data.dataType ? data.dataType : '',
                  key: data.dataId + (data.dataType ? data.dataType : '') + ((data.dataType === 'NODE_BETWEEN_BRANCH' || data.dataType === 'NODE_BETWEEN_USER') ? localStorage.getItem('enterpriseId') : (data.parentId ? data.parentId : '')),
                  parentType: (data.dataType === 'NODE_BETWEEN_BRANCH' || data.dataType === 'NODE_BETWEEN_USER') ? enterpriseType : (data.parentType ? data.parentType : null),
                  parentId: (data.dataType === 'NODE_BETWEEN_BRANCH' || data.dataType === 'NODE_BETWEEN_USER') ? localStorage.getItem('enterpriseId') : (data.parentId ? data.parentId : null)
                }))];

                this.dataTreeSelected = [...this.listDataTreeSelected.map((node) => ({
                  id: null,
                  groupUserId: this.groupUserId,
                  dataId: node.id,
                  parentId: node.parentId ? node.parentId : null,
                  dataType: node.type,
                  parentType: node.parentType ? node.parentType : null
                }))];
                this.defaultCheckedKeys = [...rs.data.groupUserDataPermissionDTOS.map((item) => item.dataId + item.dataType + ((item.dataType === 'NODE_BETWEEN_BRANCH' || item.dataType === 'NODE_BETWEEN_USER') ? localStorage.getItem('enterpriseId') : (item.parentId ? item.parentId : '')))];
              }

              if(rs.data.dataType === 'ALL_SERVICE_TYPE') {
                this.isSelectAllDocType = true;
                this.listTypes = [...[]];
                this.serviceTypes = [...[]];
              } else {
                this.isSelectAllDocType = false;
                rs.data.managerPermissionServiceType.forEach(serviceTypeId => {
                  this.listTypes = [...this.listTypes.filter((serviceType) => serviceTypeId !== serviceType.id)];
                  if(this.serviceTypes.filter((serviceType) => serviceType.id === serviceTypeId).length) {
                    this.listTags.push(this.serviceTypes.find((serviceType) => serviceType.id === serviceTypeId));
                    this.selectDocTypeMap.set(serviceTypeId, this.serviceTypes.find((serviceType) => serviceType.id === serviceTypeId));
                  }
                  this.serviceTypes = [...this.serviceTypes.filter((serviceType) => serviceType.id !== serviceTypeId)];
                });
                setTimeout(() => {
                  this.listTags = [...this.listTags.filter((data) => data !== undefined)];
                  this.serviceTypePermission = [...this.listTags.map((data) => data.id)];
                }, 1000);
              }

              this.isStatusDocument = true;
            } else {
              this.isStatusDocument = false;
            }
            // check số hóa
            const feature = featureGroup.data.find(f => f.code === 'ae.qlshhd');
            if (
                feature &&
                rs.data.featureGroupIds &&
                rs.data.featureGroupIds.length &&
                rs.data.featureGroupIds.includes(feature.id)
            ) {
              if(rs.data.groupUserDataPermissionDigitalDTOS && rs.data.groupUserDataPermissionDigitalDTOS.length) {
                const enterpriseType = localStorage.getItem('isParent') == 'true' ? 'COMPANY' : 'BRANCH';
                this.listDataTreeSelectedDigital = [...rs.data.groupUserDataPermissionDigitalDTOS.map((data) => ({
                  ...data,
                  id: data.dataId,
                  type: data.dataType ? data.dataType : '',
                  key: data.dataId + (data.dataType ? data.dataType : '') + ((data.dataType === 'NODE_BETWEEN_BRANCH' || data.dataType === 'NODE_BETWEEN_USER') ? localStorage.getItem('enterpriseId') : (data.parentId ? data.parentId : '')),
                  parentType: (data.dataType === 'NODE_BETWEEN_BRANCH' || data.dataType === 'NODE_BETWEEN_USER') ? enterpriseType : (data.parentType ? data.parentType : null),
                  parentId: (data.dataType === 'NODE_BETWEEN_BRANCH' || data.dataType === 'NODE_BETWEEN_USER') ? localStorage.getItem('enterpriseId') : (data.parentId ? data.parentId : null)
                }))];

                this.dataTreeSelectedDigital = [...this.listDataTreeSelectedDigital.map((node) => ({
                  id: null,
                  groupUserId: this.groupUserId,
                  dataId: node.id,
                  parentId: node.parentId ? node.parentId : null,
                  dataType: node.type,
                  parentType: node.parentType ? node.parentType : null
                }))];
                this.defaultCheckedKeysDigital = [...rs.data.groupUserDataPermissionDigitalDTOS.map((item) => item.dataId + item.dataType + ((item.dataType === 'NODE_BETWEEN_BRANCH' || item.dataType === 'NODE_BETWEEN_USER') ? localStorage.getItem('enterpriseId') : (item.parentId ? item.parentId : '')))];
              }
              this.isStatusDigital = true;
            } else {
              this.isStatusDigital = false;
            }

            if(rs.data.featureGroupIds && rs.data.featureGroupIds.length && rs.data.featureGroupIds.includes(featureGroup.data.find((feature) => feature.code === 'ae.qlhdcs').id)) {
              this.isStatusSharePartner = true
            } else {
              this.isStatusSharePartner = false
            }
            if(rs.data.featureGroupIds && rs.data.featureGroupIds.length && rs.data.featureGroupIds.includes(featureGroup.data.find((feature) => feature.code === 'hdld.pqch').id)) {
              this.isStatusContractStandardization = true
            } else {
              this.isStatusContractStandardization = false
            }
            if(rs.data.featureGroupIds && rs.data.featureGroupIds.length && rs.data.featureGroupIds.includes(featureGroup.data.find((feature) => feature.code === 'hdld.qlbhs').id)) {
              this.isStatusContractDossier = true
            } else {
              this.isStatusContractDossier = false
            }
          } else {
            this.isStatusDigital = false;
            this.isStatusDocument = false;
          }
        });

        this.listTypes = [...this.listTypes.slice(0, 9)];
        this.getDataTree();
        this.loadFuture();

      } else {
        this.grUs = this.grDefualt;
      }
    });
  }

  /**
   * Map feature to show
   */
  private mapGroupUser() {
    const isParentEnterprise = localStorage.getItem('isParent');
    this.dataRole = this.featuresGroups.data.map(feGr => {
      feGr.active = false;
      if (this.permissionInGroup != null && this.permissionInGroup.length > 0) {
        let data: any;
        data = this.permissionInGroup.filter(per => {
          return per === feGr.id;
        });
        if (data.length > 0) {
          feGr.active = true;
        }
      }

      /**
       * Map id to get feature to show Manager document
       */
      if (feGr.id === this.grUs.signServiceTypeFeatureGroupId && this.subSignPermission
        && this.subSignPermission.data && this.subSignPermission.data.length > 0) {
        feGr.subSignPermission = this.subSignPermission.data.map(sub => {
          if (this.signPermission != null && this.signPermission.length > 0) {
            let data: any;
            data = this.signPermission.filter(sb => {
              return sb === sub.id;
            });

            if (data.length > 0) {
              sub.active = true;
            }
          }
          return sub;
        });
        feGr.active = feGr.subSignPermission.every((item: { active: any }) => {
          return item.active;
        });
      }

      feGr.child = this.features.data.filter(fe => {
        if (fe.code !== 'ae.qlttnd.cnttdn') {
          if (isParentEnterprise) {
            return fe.featureGroupId === feGr.id;
          } else {
            if (fe.code !== 'ae.qlttdn.qlttcn' && fe.code !== 'ae.qlttdn.qlldv') {
              return fe.featureGroupId === feGr.id;
            } else {
              return false;
            }
          }
        } else {
          return false;
        }
        // return fe.featureGroupId === feGr.id && fe.code !== 'ae.qlttnd.cnttdn';
      });

      return feGr;
    }).filter(r => r.code !== 'ae.qldmtl' && r.code !== 'ae.kstl');

    const digitalGr = this.dataRole.filter(item => item.code === 'ae.qlshhd');
    if (this.digitalStatus === false) {
      this.dataRole.splice(this.dataRole.indexOf(digitalGr), 1);
    }

    let createSideFeGrIndex = -1;
    let receiveSideFeGrIndex = -1;
    this.dataRole.forEach((feGr, index) => {
      if (feGr.code === "ae.qlhdct") {
        createSideFeGrIndex = index;
      }
      if (feGr.code === "ae.qlhddt") {
        receiveSideFeGrIndex = index;
      }
      if (feGr.code === 'ae.qllhd') {
        createSideFeGrIndex = index;
      }
    });
    if (createSideFeGrIndex > -1 && receiveSideFeGrIndex > -1) {
      const tempFeGr = this.dataRole[createSideFeGrIndex];
      this.dataRole[createSideFeGrIndex] = this.dataRole[receiveSideFeGrIndex];
      this.dataRole[receiveSideFeGrIndex] = tempFeGr;
    }
    this.dataRole.forEach(data => {
      if(data.code === 'ae.qlhdct') {
        this.manageContractCreate = data;
      }
      if (data.code === 'ae.qlshhd') {
        this.manageContractDigital = data;
      }
      if (data.code === 'ae.qllhd') {
        this.manageContractCreate2 = data;
      }
      if (data.code === 'ae.qlhdcs') {
        this.manageContractShare = data;
      }
      if (data.code === 'hdld.pqch') {
        this.manageContractStandardization = data;
      }
      if (data.code === 'hdld.qlbhs') {
        this.manageContractDossier = data;
      }
    });

    
    const indexPermissionCustomerManagement = this.dataRole.findIndex((item) => item.code === 'ae.qlttkh');
    const startIndex = this.dataRole.findIndex((item) => item.code === '401.tmkh');
    const elementCustomerGroups = this.dataRole.splice(startIndex, 5);
    this.dataRole.splice(indexPermissionCustomerManagement + 1, 0, ...elementCustomerGroups);

    const listCodePermissionCustomerManagement: String[] = ['401.tmkh', '402.xdskh', '403.cntbdskh', '404.qlnkh', '405.xdlkh', '406.xmnkh'];

    if(this.dataRole.find((data) => data.code === 'ae.qlttkh').active) {
      this.dataRole.map(item => {
        if (listCodePermissionCustomerManagement.includes(item.code)) {
          item.active = true;
          return item;
        }
      });
    } else {
      if(
        this.dataRole.find((data) => data.code === '401.tmkh').active &&
        this.dataRole.find((data) => data.code === '402.xdskh').active &&
        this.dataRole.find((data) => data.code === '403.cntbdskh').active &&
        this.dataRole.find((data) => data.code === '404.qlnkh').active &&
        this.dataRole.find((data) => data.code === '405.xdlkh').active && 
        this.dataRole.find((data) => data.code === '406.xmnkh').active 
      ) {
        this.dataRole.map(item => {
          if (item.code === 'ae.qlttkh') {
            item.active = true;
            return item;
          }
        });
      }
    }
    

    this.dataRole = [...this.dataRole.filter((item) => item.code !== 'ae.qlhdct')];
    this.dataRole = [...this.dataRole.filter((item) => item.code !== 'ae.qlshhd')];
    
    // trừ đi 3 thằng 'ae.qldmtl' && 'ae.kstl' && 'ae.qlhdct'
    // if ((this.featuresGroups.data.length - ((!this.isStatusDocument ? 3 : 2) + (!this.isStatusDigital ? 1 : 0))) === this.permissionInGroup.length) {
    //   this.checkAll = true;
    // }

    const permissionData = this.permissionInGroup.map(e => {
      const info = this.featuresGroups.data.find(data => data.id === e);
      if (info) {
        return {
            ...info
        }
      }
    });
    // kiểm tra dữ liệu cũ và mới có đủ code hay không để check all
    let checkTick:boolean = true;
    let checkTickOld:boolean = true;
    PERMISS_DIVISION.forEach(e => {
      const code = permissionData.find(per => per.code === e);
      if (!code) {
        checkTick = false;
      }
    });
    PERMISS_DIVISION_DATA_OLD.forEach(e => {
      const code = permissionData.find(per => per.code === e);
      if (!code) {
        checkTickOld = false;
      }
    });
    if (checkTick || checkTickOld) {
      this.checkAll = true;
    }    
    this.dataRole = [...this.dataRole.filter((item) => item.code !== 'ae.qllhd')];
    this.reorderItems(this.dataRole)

    const permission402 = [ '406.xmnkh', '402.xdskh']


    if(this.dataRole.find((data) => data.code === '402.parent.406').active) {
      this.dataRole.map(item => {
        if (permission402.includes(item.code)) {
          item.active = true;
          return item;
        }
      });
    } else {
      if(
        this.dataRole.find((data) => data.code === '402.xdskh').active &&
        this.dataRole.find((data) => data.code === '406.xmnkh').active 
      ) {
        this.dataRole.map(item => {
          if (item.code === '402.parent.406') {
            item.active = true;
            return item;
          }
        });
      }
    }
  }

  /**
   * Event when click button cancel
   */
  onClickBtnCancel() {
    if (this.isFormChanging || this.change) {
      const dialogRe = this.dialog.open(WarningComponent, {
        width: '350px',
        data: this.message.getMessage('messages.confirm_change_data')
      });
      dialogRe.afterClosed().subscribe(rs => {
        if (rs) {
          this.location.back();
        }
        dialogRe.close();
      });
    } else {
      this.location.back();
    }
  }

  /**
   * Confirm before navigation
   */
  canDeactivate() {
    if (!this.isFormChanging) {
      return true;
    } else {
      const dialogRe = this.dialog.open(WarningComponent, {
        width: '350px',
        data: this.message.getMessage('messages.confirm_change_data')
      });
      return dialogRe.afterClosed().pipe(map(result => {
        if (result) {
          return true;
        } else {
          return false;
        }
      }), first());
    }
  }


  getServiceTypeByEnterprise() {
    const enterpriseId = localStorage.getItem('enterpriseId');
    this.isServiceTypesLoading = true;
    this.commonService.getEnterpriseServiceType(enterpriseId).subscribe(rs => {
      this.isServiceTypesLoading = false;
      if (rs && rs.data) {
        this.serviceTypes = rs.data;
        this.serviceTypes2 = rs.data;
        this.listFullServiceTypes = [...rs.data];
        this.filteredServiceTypes.next(rs.data.slice());
        this.listTypes = rs.data;
        this.listTypes2 = rs.data.slice(0, 9);
        this.filteredServiceTypes2.next(rs.data.slice());
        /* set gias tri service type */
        // this.serviceTypePermission = parseInt(this.serviceTypePermission);
      }
    }, () => this.isServiceTypesLoading = false);
  }

  searchDocumentType() {
    // listen for search field value changes
    this.searchTypeCtrl.valueChanges
      .pipe(
        startWith('')
      ).subscribe((value) => {
        if (!value) {
          this.listTypes = [...this.serviceTypes];
        }
        this.listTypes = this.serviceTypes.filter((st) =>
          st.name.toLowerCase().includes(value.trim().toLowerCase()) ||
          st.code.toLowerCase().includes(value.trim().toLowerCase())).slice(0,9);

        if(this.commonService.vietNameseConverter(this.message.getMessage('form.choose_all').toLocaleLowerCase()).includes(this.commonService.vietNameseConverter(value).toLocaleLowerCase()) || value === '') {
          this.isSearchOptionAllDocType = true;
        } else {
          this.isSearchOptionAllDocType = false;
        }

        if(''.includes(value)) {
          this.isSearchOptionVirtual = true;
        } else {
          this.isSearchOptionVirtual = false;
        }
      });
  }
  
  searchDocumentType2() {
    // listen for search field value changes
    this.searchTypeCtrl2.valueChanges
      .pipe(
        startWith('')
      ).subscribe((value) => {
        if (!value) {
          this.listTypes2 = [...this.serviceTypes2];
        }
        this.listTypes2 = this.serviceTypes2.filter((st) =>
          st.name.toLowerCase().includes(value.trim().toLowerCase()) ||
          st.code.toLowerCase().includes(value.trim().toLowerCase())).slice(0, 9);

          if(this.commonService.vietNameseConverter(this.message.getMessage('form.choose_all').toLocaleLowerCase()).includes(this.commonService.vietNameseConverter(value).toLocaleLowerCase()) || value === '') {
            this.isSearchOptionAllDocType2 = true;
          } else {
            this.isSearchOptionAllDocType2 = false;
          }

          if(''.includes(value)) {
            this.isSearchOptionVirtual2 = true;
          } else {
            this.isSearchOptionVirtual2 = false;
          }
      });
  }

  getManagerPermissionServiceType(): any[] {
    return this.serviceTypePermission;
  }

  // updateServiceTypePermission(serviceTypePermission: any[]) {
  //   if (serviceTypePermission != null) {
  //     this.newServiceTypePermission = [...serviceTypePermission];
  //     const orderNew = [...this.newServiceTypePermission].sort((a, b) => a - b);
  //     const orderOld = [...this.serviceTypePermission].sort((a, b) => a - b);
  //     let serviceTypeChange = false;
  //     if (orderNew.length === orderOld.length) {
  //       for (let i = 0; i < orderNew.length; i++) {
  //         if (orderNew[i] !== orderOld[i]) {
  //           serviceTypeChange = true;
  //           break;
  //         }
  //       }
  //     } else {
  //       serviceTypeChange = true;
  //     }
  //     if (serviceTypeChange === true && this.isFormChanging === false) {
  //       this.isFormChanging = true;
  //     }
  //     if (serviceTypePermission.length > 0) this.showCreateSideError = false;
  //   }
  // }

  togglePanel() {
    this.panel.toggle();
    this.renderer.setStyle(this.togglePanelButton.nativeElement, 'transform', `rotate(${this.panel.expanded ? '180' : '0'}deg)`)
  }


  /* If select create side contract permission then required at least 1 service type selected */
  checkCreateSideValid() {
    const createSidePermissionSelected = this.dataRole.find(fGr => fGr.active === true && fGr.code === 'ae.qlhdct');
    const serviceTypeId = this.getManagerPermissionServiceType();
    return !(createSidePermissionSelected && serviceTypeId.length === 0)
  }

  
  changeStatusCreateDocument(status: boolean) {
    this.isStatusCreateDocument = status;
  }

  // Tree
  changeStatusDocument(status: boolean) {
    this.isStatusDocument = status;
    this.isFormChanging = true;
  }

  changeStatusDigital(status: boolean) {
    this.isStatusDigital = status;
    this.isFormChanging = true;
    this.change = true;
  }
  changeStatusDataDigital(status: boolean) {
    this.change = true;
    this.isFormChanging = true;
    this.isStatusDataDigital = status;
  }


  searchTree() {
    if(this.treeFormControl.value !== this.valueSearchTreeOld) {
      if(!this.treeFormControl.value) {
        this.isSearchDataEmpty = false;
        this.getDataTree();
      } else {
        this.sv.searchTree(this.treeFormControl.value).subscribe((rs) => {
          if(rs && rs.data) {
            this.isSearchDataEmpty = false;
            this.patchDataTreeToArray(rs.data);
          } else {
            this.isSearchDataEmpty = true;
          }
        });
      }
      this.valueSearchTreeOld = this.treeFormControl.value;
      this.defaultCheckedKeys = [...this.defaultCheckedKeys];
    }
  }

  searchTreeDigital() {
    if(this.treeFormControlDigital.value !== this.valueSearchTreeOldDigital) {
      if(!this.treeFormControlDigital.value) {
        this.isSearchDataDigitalEmpty = false;
        this.getDataTree();
      } else {
        this.sv.searchTree(this.treeFormControlDigital.value).subscribe((rs) => {
          if(rs && rs.data) {
            this.isSearchDataDigitalEmpty = false;
            this.patchDataTreeToArrayDigital(rs.data);
          } else {
            this.isSearchDataDigitalEmpty = true;
          }
        });
      }
      this.valueSearchTreeOldDigital = this.treeFormControlDigital.value;
      this.defaultCheckedKeysDigital = [...this.defaultCheckedKeysDigital];
    }
  }

  onSelectNode(event: NzFormatEmitEvent): void {
    this.isFormChanging = true;
    let keysDataTree: any[] = [];
    if(event.nodes && event.nodes.filter((node) => node.key.includes(event.node.origin.parentId + 'TYPE_VIRTUAL')).length) {
      event.nodes.find((node) => node.key.includes(event.node.origin.parentId + 'TYPE_VIRTUAL')).isChecked = false;
      if(event.nodes.find((node) => node.key.includes(event.node.origin.parentId + 'TYPE_VIRTUAL')).parentNode.children.length === 2) {
        event.nodes.find((node) => node.key.includes(event.node.origin.parentId + 'TYPE_VIRTUAL')).parentNode.isHalfChecked = false;
      }
      event.nodes = event.nodes.filter((node) => !node.key.includes(event.node.origin.parentId + 'TYPE_VIRTUAL'));
      event.keys = event.keys.filter((node) => !node.includes(event.node.origin.parentId + 'TYPE_VIRTUAL'));
      event.checkedKeys = event.checkedKeys.filter((node) => !node.key.includes(event.node.origin.parentId + 'TYPE_VIRTUAL'));
    }

    if(event.node.isChecked) {
      this.listDataTreeSelected.push({
        ...event.node.origin,
        parentType: event.node.parentNode ? event.node.parentNode.origin.type : null
      });
      if(event.node.children.length) {
        this.listDataTreeSelected.push(...event.node.children.map((data) => ({
          ...data.origin,
          parentType: event.node.parentNode ? event.node.parentNode.origin.type : null
        })));
      }
    } else {
      if((localStorage.getItem('isParent') == 'true' && event.node.origin.type === 'COMPANY') || (localStorage.getItem('isParent') == 'false' && event.node.origin.type === 'BRANCH')) {
        this.listDataTreeSelected = [...[]];
      }
      if(this.listDataTreeSelected.filter((node) => node.id === (event.node.parentNode ? event.node.parentNode.origin.id : null)).length) {
        this.listDataTreeSelected.push(...event.node.parentNode.children.map((data) => ({
          ...data.origin,
          parentType: event.node.parentNode ? event.node.parentNode.origin.type : null
        })));
      }
      if(event.node.children.length) {
        this.listDataTreeSelected.forEach((data) => {
          event.node.children.map((tree) => tree.origin).forEach((data2) => {
            if(data.id === data2.id) {
              this.listDataTreeSelected = [...this.listDataTreeSelected.filter((node) => node.id !== data2.id)];
            }
          })
        })
      }
      this.listDataTreeSelected = [...this.listDataTreeSelected.filter((data) => data.parentId !== event.node.origin.id)];

      if(localStorage.getItem('isParent') == 'true' && this.listDataTreeSelected.filter((data) => data.type === 'COMPANY').length) {
        this.listDataTreeSelected = [...this.listDataTreeSelected.filter((node) => node.type !== 'COMPANY')];
      }

      if(localStorage.getItem('isParent') == 'false' && this.listDataTreeSelected.filter((data) => data.type === 'BRANCH').length) {
        this.listDataTreeSelected = [...this.listDataTreeSelected.filter((node) => node.type !== 'BRANCH')];
      }

      this.listDataTreeSelected = [...this.listDataTreeSelected.filter((node) => node.id !== (event.node.parentNode ? event.node.parentNode.origin.id : null))];
      this.listDataTreeSelected = [...this.listDataTreeSelected.filter((node) => node.key !== event.node.origin.key)];
    }


    this.listDataTreeSelected = [...this.listDataTreeSelected.filter((data) => !data.id.includes('nodeVirtual'))];

    this.listDataTreeSelected = [...this.listDataTreeSelected.filter((value, index, self) =>
      index === self.findIndex((t) => (
        t.key === value.key && t.parentId === value.parentId
      ))
    )];

    keysDataTree = [...this.listDataTreeSelected];

    if(!this.listDataTreeSelected.length && this.dataVirtualCheckedKeys.length) {
      this.dataVirtualCheckedKeys = [...this.dataVirtualCheckedKeys.filter((key) => !key.includes('nodeVirtualIdChecked'))];
    }

    this.dataVirtualCheckedKeys = [...this.dataVirtualCheckedKeys.filter((key) => key !== 'nodeVirtualIdChecked' + event.node.origin.parentId + 'TYPE_VIRTUAL' + event.node.origin.parentId)];
    this.dataVirtualCheckedKeys = [...this.dataVirtualCheckedKeys.filter((key) => key !== 'nodeVirtualIdUnCheck' + event.node.origin.parentId + 'TYPE_VIRTUAL' + event.node.origin.parentId)];
    if(event.node.children.length) {
      this.dataVirtualCheckedKeys = [...this.dataVirtualCheckedKeys.filter((key) => key !== 'nodeVirtualIdChecked' + event.node.origin.id + 'TYPE_VIRTUAL' + event.node.origin.id)];
      this.dataVirtualCheckedKeys = [...this.dataVirtualCheckedKeys.filter((key) => key !== 'nodeVirtualIdUnCheck' + event.node.origin.id + 'TYPE_VIRTUAL' + event.node.origin.id)];
    }

    this.defaultCheckedKeys = [...Array.from(new Set([...keysDataTree.map((data) => data.key), ...this.dataVirtualCheckedKeys]))];


    if (this.listDataTreeSelected && this.listDataTreeSelected.length) {
      this.dataTreeSelected = this.listDataTreeSelected.map((node) => ({
        id: null,
        groupUserId: this.groupUserId,
        dataId: node.id,
        parentId: node.parentId ? node.parentId : null,
        dataType: node.type,
        parentType: node.parentType ? node.parentType : null
      }));
    } else {
      this.dataTreeSelected = [];
    }
  }

  onSelectNodeDigital(event: NzFormatEmitEvent): void {
    this.isFormChanging = true;
    let keysDataTree: any[] = [];
    if(event.nodes && event.nodes.filter((node) => node.key.includes(event.node.origin.parentId + 'TYPE_VIRTUAL')).length) {
      event.nodes.find((node) => node.key.includes(event.node.origin.parentId + 'TYPE_VIRTUAL')).isChecked = false;
      if(event.nodes.find((node) => node.key.includes(event.node.origin.parentId + 'TYPE_VIRTUAL')).parentNode.children.length === 2) {
        event.nodes.find((node) => node.key.includes(event.node.origin.parentId + 'TYPE_VIRTUAL')).parentNode.isHalfChecked = false;
      }
      event.nodes = event.nodes.filter((node) => !node.key.includes(event.node.origin.parentId + 'TYPE_VIRTUAL'));
      event.keys = event.keys.filter((node) => !node.includes(event.node.origin.parentId + 'TYPE_VIRTUAL'));
      event.checkedKeys = event.checkedKeys.filter((node) => !node.key.includes(event.node.origin.parentId + 'TYPE_VIRTUAL'));
    }

    if(event.node.isChecked) {
      this.listDataTreeSelectedDigital.push({
        ...event.node.origin,
        parentType: event.node.parentNode ? event.node.parentNode.origin.type : null
      });
      if(event.node.children.length) {
        this.listDataTreeSelectedDigital.push(...event.node.children.map((data) => ({
          ...data.origin,
          parentType: event.node.parentNode ? event.node.parentNode.origin.type : null
        })));
      }
    } else {
      if((localStorage.getItem('isParent') == 'true' && event.node.origin.type === 'COMPANY') || (localStorage.getItem('isParent') == 'false' && event.node.origin.type === 'BRANCH')) {
        this.listDataTreeSelectedDigital = [...[]];
      }
      if(this.listDataTreeSelectedDigital.filter((node) => node.id === (event.node.parentNode ? event.node.parentNode.origin.id : null)).length) {
        this.listDataTreeSelectedDigital.push(...event.node.parentNode.children.map((data) => ({
          ...data.origin,
          parentType: event.node.parentNode ? event.node.parentNode.origin.type : null
        })));
      }
      if(event.node.children.length) {
        this.listDataTreeSelectedDigital.forEach((data) => {
          event.node.children.map((tree) => tree.origin).forEach((data2) => {
            if(data.id === data2.id) {
              this.listDataTreeSelectedDigital = [...this.listDataTreeSelectedDigital.filter((node) => node.id !== data2.id)];
            }
          })
        })
      }
      this.listDataTreeSelectedDigital = [...this.listDataTreeSelectedDigital.filter((data) => data.parentId !== event.node.origin.id)];

      if(localStorage.getItem('isParent') == 'true' && this.listDataTreeSelectedDigital.filter((data) => data.type === 'COMPANY').length) {
        this.listDataTreeSelectedDigital = [...this.listDataTreeSelectedDigital.filter((node) => node.type !== 'COMPANY')];
      }

      if(localStorage.getItem('isParent') == 'false' && this.listDataTreeSelectedDigital.filter((data) => data.type === 'BRANCH').length) {
        this.listDataTreeSelectedDigital = [...this.listDataTreeSelectedDigital.filter((node) => node.type !== 'BRANCH')];
      }

      this.listDataTreeSelectedDigital = [...this.listDataTreeSelectedDigital.filter((node) => node.id !== (event.node.parentNode ? event.node.parentNode.origin.id : null))];
      this.listDataTreeSelectedDigital = [...this.listDataTreeSelectedDigital.filter((node) => node.key !== event.node.origin.key)];
    }


    this.listDataTreeSelectedDigital = [...this.listDataTreeSelectedDigital.filter((data) => !data.id.includes('nodeVirtual'))];

    this.listDataTreeSelectedDigital = [...this.listDataTreeSelectedDigital.filter((value, index, self) =>
      index === self.findIndex((t) => (
        t.key === value.key && t.parentId === value.parentId
      ))
    )];

    keysDataTree = [...this.listDataTreeSelectedDigital];

    if(!this.listDataTreeSelectedDigital.length && this.dataVirtualCheckedKeysDigital.length) {
      this.dataVirtualCheckedKeysDigital = [...this.dataVirtualCheckedKeysDigital.filter((key) => !key.includes('nodeVirtualIdChecked'))];
    }

    this.dataVirtualCheckedKeysDigital = [...this.dataVirtualCheckedKeysDigital.filter((key) => key !== 'nodeVirtualIdChecked' + event.node.origin.parentId + 'TYPE_VIRTUAL' + event.node.origin.parentId)];
    this.dataVirtualCheckedKeysDigital = [...this.dataVirtualCheckedKeysDigital.filter((key) => key !== 'nodeVirtualIdUnCheck' + event.node.origin.parentId + 'TYPE_VIRTUAL' + event.node.origin.parentId)];
    if(event.node.children.length) {
      this.dataVirtualCheckedKeysDigital = [...this.dataVirtualCheckedKeysDigital.filter((key) => key !== 'nodeVirtualIdChecked' + event.node.origin.id + 'TYPE_VIRTUAL' + event.node.origin.id)];
      this.dataVirtualCheckedKeysDigital = [...this.dataVirtualCheckedKeysDigital.filter((key) => key !== 'nodeVirtualIdUnCheck' + event.node.origin.id + 'TYPE_VIRTUAL' + event.node.origin.id)];
    }

    this.defaultCheckedKeysDigital = [...Array.from(new Set([...keysDataTree.map((data) => data.key), ...this.dataVirtualCheckedKeysDigital]))];


    if (this.listDataTreeSelectedDigital && this.listDataTreeSelectedDigital.length) {
      this.dataTreeSelectedDigital = this.listDataTreeSelectedDigital.map((node) => ({
        id: null,
        groupUserId: this.groupUserId,
        dataId: node.id,
        parentId: node.parentId ? node.parentId : null,
        dataType: node.type,
        parentType: node.parentType ? node.parentType : null
      }));
    } else {
      this.dataTreeSelectedDigital = [];
    }
  }

  expandParentNode(event: NzFormatEmitEvent) {
    if((localStorage.getItem('isParent') == 'true' && event.node.origin.type === 'COMPANY') || (localStorage.getItem('isParent') == 'false' && event.node.origin.type === 'BRANCH')) {
      return;
    }
    setTimeout(() => {
      document.querySelectorAll('.hide-class').forEach((item) => {
        item.parentElement.parentElement.parentElement.classList.add('display-none');
      })
    }, 0);
    if (!this.treeFormControl.value) {
      if (event.node.isExpanded) {
        let dataTreeSelectedByParent = this.dataTreeSelected.filter((data) => data.parentId === event.node.origin.id);
        event.node.clearChildren();
        this.sv.getTreeNodes({ parentId: event.node.origin.id, parentType: event.node.origin.type }).pipe(
          map((rs) => rs.data.map((node) => ({
            title: node.name,
            id: node.id,
            level: 3,
            parentId: node.parentId,
            key: node.id + node.type + node.parentId,
            type: node.type,
            children: [],
            isActive: node.isActive,
            isLeaf: !node.isParent,
          })))
        ).subscribe((res) => {
          if(res && res.length) {
            event.node.addChildren(res);
            event.node.addChildren([
              {
                type: 'TYPE_VIRTUAL',
                id: 'nodeVirtualId' + (event.node.origin.id ? event.node.origin.id : ''),
                key: event.node.origin.id + 'TYPE_VIRTUAL' + event.node.origin.id,
                level: 3,
                parentId: event.node.origin.id,
                title: 'node virtual',
                children: [],
                isActive: true,
                isLeaf: true,
              }
            ]);

            dataTreeSelectedByParent.forEach((data) => {
              if(!res.filter((node) => data.dataId === node.id).length) {
                this.dataTreeSelected = [...this.dataTreeSelected.filter((dataSelected) => dataSelected.dataId !== data.dataId)];
                this.defaultCheckedKeys =[... this.defaultCheckedKeys.filter((keySelected) => keySelected !== data.dataId + data.dataType + data.parentId)];
              }
            });

            if (event.node.isChecked) {
              this.defaultCheckedKeys = [...this.defaultCheckedKeys, ...res.map((data) => data.key), event.node.origin.id + 'TYPE_VIRTUAL' + event.node.origin.id];
              this.defaultCheckedKeys = Array.from(new Set(this.defaultCheckedKeys));
            }
            this.defaultCheckedKeys = [...this.defaultCheckedKeys];
          } else {
            this.toastr.error(this.message.getMessage('user_group.message_data_changed'));
          }
        })
      }
    }
  }

  expandParentNodeDigital(event: NzFormatEmitEvent) {
    if((localStorage.getItem('isParent') == 'true' && event.node.origin.type === 'COMPANY') || (localStorage.getItem('isParent') == 'false' && event.node.origin.type === 'BRANCH')) {
      return;
    }
    setTimeout(() => {
      document.querySelectorAll('.hide-class').forEach((item) => {
        item.parentElement.parentElement.parentElement.classList.add('display-none');
      })
    }, 0);
    if (!this.treeFormControlDigital.value) {
      if (event.node.isExpanded) {
        let dataTreeSelectedByParent = this.dataTreeSelectedDigital.filter((data) => data.parentId === event.node.origin.id);
        event.node.clearChildren();
        this.sv.getTreeNodes({ parentId: event.node.origin.id, parentType: event.node.origin.type }).pipe(
          map((rs) => rs.data.map((node) => ({
            title: node.name,
            id: node.id,
            level: 3,
            parentId: node.parentId,
            key: node.id + node.type + node.parentId,
            type: node.type,
            children: [],
            isActive: node.isActive,
            isLeaf: !node.isParent,
          })))
        ).subscribe((res) => {
          if(res && res.length) {
            event.node.addChildren(res);
            event.node.addChildren([
              {
                type: 'TYPE_VIRTUAL',
                id: 'nodeVirtualId' + (event.node.origin.id ? event.node.origin.id : ''),
                key: event.node.origin.id + 'TYPE_VIRTUAL' + event.node.origin.id,
                level: 3,
                parentId: event.node.origin.id,
                title: 'node virtual',
                children: [],
                isActive: true,
                isLeaf: true,
              }
            ]);

            dataTreeSelectedByParent.forEach((data) => {
              if(!res.filter((node) => data.dataId === node.id).length) {
                this.dataTreeSelectedDigital = [...this.dataTreeSelectedDigital.filter((dataSelected) => dataSelected.dataId !== data.dataId)];
                this.defaultCheckedKeysDigital =[... this.defaultCheckedKeysDigital.filter((keySelected) => keySelected !== data.dataId + data.dataType + data.parentId)];
              }
            });

            if (event.node.isChecked) {
              this.defaultCheckedKeysDigital = [...this.defaultCheckedKeysDigital, ...res.map((data) => data.key), event.node.origin.id + 'TYPE_VIRTUAL' + event.node.origin.id];
              this.defaultCheckedKeysDigital = Array.from(new Set(this.defaultCheckedKeysDigital));
            }
            this.defaultCheckedKeysDigital = [...this.defaultCheckedKeysDigital];
          } else {
            this.toastr.error(this.message.getMessage('user_group.message_data_changed'));
          }
        })
      }
    }
  }

  listToTree(list: any[]) {
    if(localStorage.getItem('isParent') == 'true') {
      this.enterpriseType = 'COMPANY';
    } else {
      this.enterpriseType = 'BRANCH';
    }
    let map: any = {};
    let node: any;
    let roots: any[] = [];
    let i: number;

    for (i = 0; i < list.length; i += 1) {
      map[list[i].id] = i;
      list[i].children = [];
    }

    for (i = 0; i < list.length; i += 1) {
      node = list[i];
      if (node.type != this.enterpriseType && node.parentId) {
        list[map[node.parentId]].children.push(node);
      } else {
        roots.push(node);
      }
    }
    return roots;
  }

  convertTreeToList(root: any) {
    const stack: any[] = [];
    const array: any[] = [];
    const hashMap = {};
    stack.push({
      ...root,
      level: 1,
      expand: true,
      key: root.id + root.type,
      title: root.name,
      type: root.type,
    });
    this.defaultExpandedKeys = [root.id + root.type];
    while (stack.length !== 0) {
      const node: any = stack.pop()!;
      this.visitNode(node, hashMap, array);
      if (node.subTrees) {
        node['children'] = node.subTrees;
        for (let i = node.children.length - 1; i >= 0; i--) {
          stack.push({
            ...node.children[i],
            level: node.level! + 1,
            title: node.children[i].name,
            type: node.children[i].type,
            key: node.children[i].id + node.children[i].type + node.id,
            expand: true,
            // head: node
          });
          if(this.treeFormControl.value) {
            this.defaultExpandedKeys = [...this.defaultExpandedKeys, node.children[i].id + node.children[i].type + node.id];
          }
        }
      }
    }

    return array;
  }

  convertTreeToListDigital(root: any) {
    const stack: any[] = [];
    const array: any[] = [];
    const hashMap = {};
    stack.push({
      ...root,
      level: 1,
      expand: true,
      key: root.id + root.type,
      title: root.name,
      type: root.type,
    });
    this.defaultExpandedKeysDigital = [root.id + root.type];
    while (stack.length !== 0) {
      const node: any = stack.pop()!;
      this.visitNode(node, hashMap, array);
      if (node.subTrees) {
        node['children'] = node.subTrees;
        for (let i = node.children.length - 1; i >= 0; i--) {
          stack.push({
            ...node.children[i],
            level: node.level! + 1,
            title: node.children[i].name,
            type: node.children[i].type,
            key: node.children[i].id + node.children[i].type + node.id,
            expand: true,
            // head: node
          });
          if(this.treeFormControlDigital.value) {
            this.defaultExpandedKeysDigital = [...this.defaultExpandedKeysDigital, node.children[i].id + node.children[i].type + node.id];
          }
        }
      }
    }

    return array;
  }

  visitNode(
    node: any,
    hashMap: { [key: string]: boolean },
    array: any[]
  ): void {
    const id = this.getNodeId(node);
    if (!hashMap[id]) {
      hashMap[id] = true;
    }
    array.push(node);
  }

  getNodeId(node: any) {
    if (node.id) {
      return node.id;
    }
    return node.companyId || '';
  }

  getDataTree() {
    this.sv.getTree().subscribe((rs) => {
      if (rs && rs.data) {
        const dataDocument = JSON.parse(JSON.stringify(rs.data));
        const dataDigital = JSON.parse(JSON.stringify(rs.data));
        this.patchDataTreeToArray(dataDocument);
        this.patchDataTreeToArrayDigital(dataDigital);
      }
    })
  }

  addNodeVirtual(array: any) {
    if(array.length) {
      array.forEach((item) => {
        if(item.subTrees && item.subTrees.length) {
          item.subTrees.push({
            id: 'nodeVirtualId' + (item.id ? item.id : ''),
            name: 'node virtual',
            type: 'TYPE_VIRTUAL',
            isActive: true,
            subTrees: [],
            roleDTOS: null,
            parentId: item.id,
          });
          this.addNodeVirtual(item.subTrees);
        }
      })
    }
  }

  addNodeVirtualDigital(array: any) {
    if(array.length) {
      array.forEach((item) => {
        if(item.subTrees && item.subTrees.length) {
          item.subTrees.push({
            id: 'nodeVirtualId' + (item.id ? item.id : ''),
            name: 'node virtual',
            type: 'TYPE_VIRTUAL',
            isActive: true,
            subTrees: [],
            roleDTOS: null,
            parentId: item.id,
          });
          this.addNodeVirtualDigital(item.subTrees);
        }
      })
    }
  }

  addNodeVirtualInNodeParentHalfChecked(array: any) {
    if (array.length) {
      array.forEach((item) => {
        if(this.dataTreeSelected.length && this.treeFormControl.value) {
          if(!item.subTrees.filter((data) => data.id.includes('nodeVirtualIdChecked')).length) {
            item.subTrees.push(...[
              {
                id: 'nodeVirtualIdChecked' + item.id,
                name: 'node virtual checked',
                type: 'TYPE_VIRTUAL',
                isActive: true,
                subTrees: [],
                roleDTOS: null,
                parentId: item.id,
              },
              {
                id: 'nodeVirtualIdUnCheck' + item.id,
                name: 'node virtual uncheck',
                type: 'TYPE_VIRTUAL',
                isActive: true,
                subTrees: [],
                roleDTOS: null,
                parentId: item.id,
              }
            ]);
            this.dataVirtualCheckedKeys.push('nodeVirtualIdChecked' + item.id + 'TYPE_VIRTUAL' + item.id);
          }
        }
        if (item.subTrees && item.subTrees.length) {
          this.listDataTreeSelected.forEach((dataTreeSelected) => {
            item.subTrees.forEach(dataTree => {
              if (dataTreeSelected.parentId === dataTree.id) {
                if(!dataTree.subTrees.filter((data) => data.id.includes('nodeVirtualIdChecked')).length) {
                  dataTree.subTrees.push(...[
                    {
                      id: 'nodeVirtualIdChecked' + dataTree.id,
                      name: 'node virtual checked',
                      type: 'TYPE_VIRTUAL',
                      isActive: true,
                      subTrees: [],
                      roleDTOS: null,
                      parentId: dataTree.id,
                    },
                    {
                      id: 'nodeVirtualIdUnCheck' + dataTree.id,
                      name: 'node virtual uncheck',
                      type: 'TYPE_VIRTUAL',
                      isActive: true,
                      subTrees: [],
                      roleDTOS: null,
                      parentId: dataTree.id,
                    }
                  ]);
                  this.dataVirtualCheckedKeys.push('nodeVirtualIdChecked' + dataTree.id + 'TYPE_VIRTUAL' + dataTree.id);
                }
              }
            });
          })
        }
      })
    }
  }

  addNodeVirtualInNodeParentHalfCheckedDigital(array: any) {
    if (array.length) {
      array.forEach((item) => {
        if(this.dataTreeSelectedDigital.length && this.treeFormControlDigital.value) {
          if(!item.subTrees.filter((data) => data.id.includes('nodeVirtualIdChecked')).length) {
            item.subTrees.push(...[
              {
                id: 'nodeVirtualIdChecked' + item.id,
                name: 'node virtual checked',
                type: 'TYPE_VIRTUAL',
                isActive: true,
                subTrees: [],
                roleDTOS: null,
                parentId: item.id,
              },
              {
                id: 'nodeVirtualIdUnCheck' + item.id,
                name: 'node virtual uncheck',
                type: 'TYPE_VIRTUAL',
                isActive: true,
                subTrees: [],
                roleDTOS: null,
                parentId: item.id,
              }
            ]);
            this.dataVirtualCheckedKeysDigital.push('nodeVirtualIdChecked' + item.id + 'TYPE_VIRTUAL' + item.id);
          }
        }
        if (item.subTrees && item.subTrees.length) {
          this.listDataTreeSelectedDigital.forEach((dataTreeSelected) => {
            item.subTrees.forEach(dataTree => {
              if (dataTreeSelected.parentId === dataTree.id) {
                if(!dataTree.subTrees.filter((data) => data.id.includes('nodeVirtualIdChecked')).length) {
                  dataTree.subTrees.push(...[
                    {
                      id: 'nodeVirtualIdChecked' + dataTree.id,
                      name: 'node virtual checked',
                      type: 'TYPE_VIRTUAL',
                      isActive: true,
                      subTrees: [],
                      roleDTOS: null,
                      parentId: dataTree.id,
                    },
                    {
                      id: 'nodeVirtualIdUnCheck' + dataTree.id,
                      name: 'node virtual uncheck',
                      type: 'TYPE_VIRTUAL',
                      isActive: true,
                      subTrees: [],
                      roleDTOS: null,
                      parentId: dataTree.id,
                    }
                  ]);
                  this.dataVirtualCheckedKeysDigital.push('nodeVirtualIdChecked' + dataTree.id + 'TYPE_VIRTUAL' + dataTree.id);
                }
              }
            });
          })
        }
      })
    }
  }

  patchDataTreeToArray(data: any) {
    this.addNodeVirtual([data]);
    if(this.listDataTreeSelected.length) {
      this.addNodeVirtualInNodeParentHalfChecked([data]);
      this.defaultCheckedKeys = Array.from(new Set([...this.defaultCheckedKeys, ...this.dataVirtualCheckedKeys]));
    }

    [data].forEach((item: any) => {
      this.tempDataToTree = this.convertTreeToList(item).map((res) =>
        this.convertDataResponse(res)
      );
      this.defaultCheckedKeys = [...this.defaultCheckedKeys];

      this.featuresTree = [...this.listToTree(this.tempDataToTree)];
      setTimeout(() => {
        document.querySelectorAll('.hide-class').forEach((item) => {
          item.parentElement.parentElement.parentElement.classList.add('display-none');
        })
      }, 0);
    });

    if(data && data.subTrees.length) {
      data.subTrees.forEach((node) => {
        if(node.type === 'NODE_BETWEEN_USER') {
          this.infoNodeBetweenUser = { ...this.infoNodeBetweenUser, id: node.id, type: node.type };
        }
      });
    }
  }

  patchDataTreeToArrayDigital (data: any) {
    this.addNodeVirtualDigital([data]);
    if(this.dataTreeSelectedDigital.length) {
      this.addNodeVirtualInNodeParentHalfCheckedDigital([data]);
      this.defaultCheckedKeysDigital = Array.from(new Set([...this.defaultCheckedKeysDigital, ...this.dataVirtualCheckedKeysDigital]));
    }

    [data].forEach((item: any) => {
      this.tempDataToTreeDigital = this.convertTreeToListDigital(item).map((res) =>
        this.convertDataResponse(res)
      );
      this.defaultCheckedKeysDigital = [...this.defaultCheckedKeysDigital];

      this.featuresTreeDigital = [...this.listToTree(this.tempDataToTreeDigital)];
      setTimeout(() => {
        document.querySelectorAll('.hide-class').forEach((item) => {
          item.parentElement.parentElement.parentElement.classList.add('display-none');
        })
      }, 0);
    });

    if(data && data.subTrees.length) {
      data.subTrees.forEach((node) => {
        if(node.type === 'NODE_BETWEEN_USER') {
          this.infoNodeBetweenUser = { ...this.infoNodeBetweenUser, id: node.id, type: node.type };
        }
      });
    }
  }

  convertDataResponse(data: any) {
    let newData: any = {};
    newData.title = data.name;
    newData.id = data.id;
    newData.level = data.level;
    newData.parentId = data.parentId;
    newData.key = data.key;
    newData.type = data.type;
    newData.children = data.children;
    newData.expanded = false;
    newData.isActive = data.isActive
    newData.isLeaf = !data.isParent;
    return newData;
  }

  beforeDrop(arg: NzFormatBeforeDropEvent): Observable<boolean> {
    if (arg.pos === 0) {
      return of(true).pipe(delay(0));
    } else {
      return of(false);
    }
  }

  clickOptiondocTypeAll() {
    this.isSelectAllDocType = true;
    this.serviceTypePermission = [...[]];
    this.listTags = [...[]];
    this.listTypes = [...[]];
    this.serviceTypes = [...[]];
  }

  clickOptiondocType(docType) {
    if (docType) {
      if (this.selectDocTypeMap.has(docType.id)) {
        this.selectDocTypeMap.delete(docType.id);
        this.serviceTypes.push(docType);
        this.serviceTypes = [...this.serviceTypes.sort((a, b) => {
          if(a.name < b.name) {
            return -1;
          } else if(a.name > b.name) {
            return 1;
          } else {
            return 0;
          }
        })];
        this.listTypes = [...this.serviceTypes.slice(0,9)];
        this.docTypeSelected = '';
      } else {
        this.selectDocTypeMap.set(docType.id, docType);
        this.serviceTypes = [...this.serviceTypes.filter((data) => data.id !== docType.id)];
        this.listTypes = [...this.serviceTypes.slice(0,9)];
      }
    } else {
      if (this.selectDocTypeMap.has(0)) {
        this.selectDocTypeMap.delete(0);
      } else {
        this.selectDocTypeMap.set(0, 0);
      }
    }

    this.isFormChanging = true;

    this.listTags = [...Array.from(this.selectDocTypeMap.values())];
    this.serviceTypePermission = [...this.listTags.map((serviceType) => serviceType.id)];
  }

  removeAllTags() {
    this.isSelectAllDocType = false;
    this.listTags = [...[]];
    this.listTypes = [...this.listFullServiceTypes].slice(0,9);;
    this.serviceTypes = [...this.listFullServiceTypes];
    this.serviceTypePermission = [...this.listTags.map((serviceType) => serviceType.id)];
    this.selectDocTypeMap.clear();
  }

  checkDisabledButton(): boolean {
    if (this.change) {
      if (!this.isStatusDocument && !this.isStatusDigital) {
        return false;
      }
      if ((this.isStatusDocument && this.dataTreeSelected.length > 0) || !this.isStatusDocument) {
        if (!this.isStatusDigital || (this.isStatusDigital && !this.isStatusDataDigital) || (this.isStatusDigital && this.isStatusDataDigital && this.dataTreeSelectedDigital.length > 0)) {
          return false;
        }
      }
      return true;
    } else {
      if (this.isStatusDocument && this.dataTreeSelected.length > 0) {
        return false;
      } else {
        return true;
      }
    }
  }

  get getPermisionSME(){
    if( JSON.parse(localStorage.getItem('permissions')).includes(2) && localStorage.getItem('isFromSSO') =='true'){
      return true
    }
    return false
  }

  selectedIndexChange(index: number) {
    this.currentIndex = index
  }

  clickOptiondocTypeAll2() {
    this.isSelectAllDocType2 = true;
    this.serviceTypePermission2 = [...[]];
    this.listTags2 = [...[]];
    this.listTypes2 = [...[]];
    this.serviceTypes2 = [...[]];
  }

  clickOptiondocType2(docType) {
    if (docType) {
      if (this.selectDocTypeMap2.has(docType.id)) {
        this.selectDocTypeMap2.delete(docType.id);
        this.serviceTypes2.push(docType);
        this.serviceTypes2 = [...this.serviceTypes2.sort((a, b) => {
          if(a.name < b.name) {
            return -1;
          } else if(a.name > b.name) {
            return 1;
          } else {
            return 0;
          }
        })];
        this.listTypes2 = [...this.serviceTypes2.slice(0,9)];
        this.docTypeSelected2 = '';
      } else {
        this.selectDocTypeMap2.set(docType.id, docType);
        this.serviceTypes2 = [...this.serviceTypes2.filter((data) => data.id !== docType.id)];
        this.listTypes2 = [...this.serviceTypes2.slice(0,9)];
      }
    } else {
      if (this.selectDocTypeMap2.has(0)) {
        this.selectDocTypeMap2.delete(0);
      } else {
        this.selectDocTypeMap2.set(0, 0);
      }
    }

    this.listTags2 = [...Array.from(this.selectDocTypeMap2.values())];
    this.serviceTypePermission2 = this.listTags2.map((serviceType) => serviceType.id);
  }

  removeAllTags2() {
    this.isSelectAllDocType2 = false;
    this.listTags2 = [...[]];
    this.listTypes2 = [...this.listFullServiceTypes].slice(0, 9);
    this.serviceTypes2 = [...this.listFullServiceTypes];
    this.serviceTypePermission2 = [...this.listTags2.map((serviceType) => serviceType.id)];
    this.selectDocTypeMap2.clear();
  }

  reorderItems(menuItems: any[]) {
    const paren402406 = {
      id: "fakeNode402Parent406",
      code: "402.parent.406",
      name: "Xem danh sách khách hàng",
      active: false,
      child: []
    }
    const index406 = menuItems.findIndex(item => item.code === '406.xmnkh');
    const index402 = menuItems.findIndex(item => item.code === '402.xdskh');
  
    if (index406 !== -1 && index402 !== -1) {
      // Lấy phần tử cần di chuyển
      const itemToMove = menuItems[index406];
  
      // Xóa phần tử đó khỏi mảng
      menuItems.splice(index406, 1);
  
      // Chèn lại vào vị trí sau phần tử 402.xdskh
      menuItems.splice(index402 + 1, 0, itemToMove);
      menuItems.splice(index402, 0, paren402406);
    }
  }

  listGroupCustomer :any = []
  inputInternalDocumentsValue:string = '';
  nzCheckLoadingParty1 = false;
  isLoading = false;
  timeOutQueryServer1 = null;
  getParentContractNew(e, value?: string) {
    this.listGroupCustomer = [];
    if (e.inputType.includes('insert') || e.inputType.includes('delete')) {
      if (!this.inputInternalDocumentsValue) {
        this.listGroupCustomer = [];
        return;
      }
      if (this.timeOutQueryServer1) {
        clearTimeout(this.timeOutQueryServer1);
      }
      this.timeOutQueryServer1 = setTimeout(() => {
      const data = {
        keyword: this.inputInternalDocumentsValue.trim(),
        page: 0,
        pageSize: 10,
      };
      this.isLoading = true;
      this.nzCheckLoadingParty1 = true;
      this.customerService.filterCustomerGroups(data)
        .subscribe(res => {
          if (res.data && res.success) {
            this.listGroupCustomer = res.data.content;
            
          } else {
            this.toastr.error(res.message);
          }
          this.nzCheckLoadingParty1 = false;
          this.isLoading = false;

        });
  },500);
    } else return;
  }

  dataListGroupCustomer: any = []
  autocompleteInternalUserSelected($event: any, model: any) {
    if ($event.isUserInput) {
      if (!this.checkExistedInternalUser(model.id)) {
        this.newDataListGroupCustomer = [
          ...this.newDataListGroupCustomer,
          {
            name: model.name,
            id: model.id,
            customerIds:model.customerIds,
          }
        ];
        if ($event.source.selected) {
          this.changeCusomer = true
        }
      } else {
        this.toastr.error(this.commonService.format(this.message.getMessage('messages.add_group_customer_duplicate'), model.name));
      }
      console.log(this.newDataListGroupCustomer);
      
    }
  }

  checkExistedInternalUser(id: string) {
    const existedList = this.newDataListGroupCustomer.filter((e) => {
      return e.id === id;
    });

    return (existedList.length > 0);
  }

  clearTag(index: number){
    this.newDataListGroupCustomer.splice(index, 1);
    this.newDataListGroupCustomer = [...this.newDataListGroupCustomer]; 
    this.changeCusomer = true

    console.log(this.newDataListGroupCustomer);
  }

  dialogRef: MatDialogRef<any> | null;
  confirmDialogRef: MatDialogRef<any> | null;
  confirmType: string = 'close'
  @ViewChild('addGroupCustomer', { static: false }) addGroupCustomer: any;
  @ViewChild('confirmPopup', { static: false }) confirmPopup: any;
  viewGroupCusomer(){
    this.newDataListGroupCustomer = [...this.dataListGroupCustomer]
    this.dialogRef = this.dialog.open(this.addGroupCustomer,{
      width: '540px',
      disableClose: true,
    })
  } 
  closeDialog(): void {
    if (this.dialogRef) {
      this.dialogRef.close('close');
      this.dialogRef = null;
      this.changeCusomer = false
      this.inputInternalDocumentsValue = ''
    }
  }
  dataDelete: any
  newDataListGroupCustomer: any = []
  openConfirmDialog(type: string, data?: any, index?: number){
    this.confirmType = type;
    if(type == 'delete'){
      this.dataDelete = {name: data.name , index: index};
    }
    if(type == 'close' && !this.changeCusomer){
      this.closeDialog()
      return
    }
    this.confirmDialogRef = this.dialog.open(this.confirmPopup,{
      width: '365px',
      disableClose: true,
    })
  }

  closeConfirmDialog(action?: string): void {
    if (action) {
      if (this.confirmDialogRef) {
        if (this.confirmType == 'close') {
          this.confirmDialogRef.close('close');
          this.confirmDialogRef = null; 
          this.closeDialog()
        } else {
          this.clearTag(this.dataDelete.index)
          this.toastr.success(this.message.getMessage('new_permission_406.delete_customer_config_success'))
          this.confirmDialogRef.close('close');
          this.confirmDialogRef = null;  
        }
      }
    } else {
      if (this.confirmDialogRef) {
        this.confirmDialogRef.close('close');
        this.confirmDialogRef = null;  
      }
    }

    
  }

  changeCusomer: boolean = false

  saveDataListGroupCustomer(){
    this.dataListGroupCustomer = [...this.newDataListGroupCustomer]
    this.toastr.success(this.message.getMessage('new_permission_406.save_customer_config_success'))
    this.closeDialog()
  }

  check406Active(): boolean{
    const q406 = this.dataRole.find(item => item.code == '406.xmnkh')
    return q406 ? q406.active : false
  }

  blurInput($event: any){
    this.inputInternalDocumentsValue = this.inputInternalDocumentsValue.trim()
  }
  
  noIncludePermissions(code: string){
    return code !== 'ae.qlhdcs' && code !== 'ae.qlhdcs.gh' && code !== 'hdld.pqch' && code !== 'hdld.qlbhs'
  }
  isStatusSharePartner: boolean = false
  manageContractShare: any;
  changeStatusSharePartner($event){
    this.isStatusSharePartner = $event
    this.dataRole.forEach(item => {
      if(item.code == 'ae.qlhdcs.gh'){
        item.active = false
      }
    })
  }

  isStatusContractStandardization: boolean = false
  manageContractStandardization: any;
  changeStatusContractStandardization($event){
    this.isStatusContractStandardization = $event
    this.dataRole.forEach(item => {
      if(item.code == 'hdld.pqch'){
        item.active = false
      }
    })
  }

  isStatusContractDossier: boolean = false
  manageContractDossier: any;
  changeStatusContractDossier($event){
    this.isStatusContractDossier = $event
    this.dataRole.forEach(item => {
      if(item.code == 'hdld.qlbhs'){
        item.active = false
      }
    })
  }
}
